import { faPen } from '@fortawesome/pro-solid-svg-icons'
import { Input } from 'antd'

import FormItem from '../../../Components/shared/Forms/FormItem'

const MetadataDisplayer = ({ className = '', metadata = {} }) => {
  const metadataFields = Object.keys(metadata)

  return (
    <div className={className}>
      {metadataFields.map((fieldName, index) =>
        <FormItem key={fieldName + '_' + index} icon={faPen} label={fieldName}>
          <Input
            disabled
            value={metadata[fieldName] === null ? '' : metadata[fieldName]}
          />
        </FormItem>
      )}
    </div>

  )
}

export default MetadataDisplayer
